import { toast as sonnerToast, type ExternalToast } from "sonner";

/** Posição explícita do Caixa — independente do Toaster global (bottom-right). */
const CAIXA_TOAST_POSITION = "top-center" as const;

const TOAST_OPTIONS: ExternalToast = {
  position: CAIXA_TOAST_POSITION,
};

function mergeOptions(data?: ExternalToast): ExternalToast {
  return { ...data, ...TOAST_OPTIONS, position: CAIXA_TOAST_POSITION };
}

function dismissCaixaToasts() {
  for (const t of sonnerToast.getToasts()) {
    if (!("position" in t)) continue;
    if (t.position === CAIXA_TOAST_POSITION) {
      sonnerToast.dismiss(t.id);
    }
  }
}

type ToastFn = (message: string, data?: ExternalToast) => string | number;

function wrapToast(fn: ToastFn): ToastFn {
  return (message, data) => {
    dismissCaixaToasts();
    return fn(message, mergeOptions(data));
  };
}

/**
 * Toasts do Caixa/PDV.
 * Sempre força `position: "top-center"` — não depende do padrão global bottom-right.
 */
export const toast = Object.assign(wrapToast(sonnerToast), {
  success: wrapToast(sonnerToast.success),
  error: wrapToast(sonnerToast.error),
  info: wrapToast(sonnerToast.info),
  warning: wrapToast(sonnerToast.warning),
  loading: wrapToast(sonnerToast.loading),
  message: wrapToast(sonnerToast.message),
  custom: sonnerToast.custom,
  dismiss: sonnerToast.dismiss,
  getHistory: sonnerToast.getHistory,
  getToasts: sonnerToast.getToasts,
  promise: <ToastData,>(
    promise: Parameters<typeof sonnerToast.promise<ToastData>>[0],
    data?: Parameters<typeof sonnerToast.promise<ToastData>>[1],
  ) => {
    dismissCaixaToasts();
    return sonnerToast.promise<ToastData>(promise, {
      ...data,
      position: CAIXA_TOAST_POSITION,
    });
  },
});

export type { ExternalToast };
